export const DOMAIN = Object.freeze({
  AUTH: 'auth',

  RFQ: 'rfq',
  QCF: 'qcf',

  SETTINGS: 'settings',
  MAPPING_MATERIAL: 'mapping-material',

  MASTER_USER: 'master-user',
  USER_MATRIX: 'user-matrix',
  MASTER_DIVISION: 'master-division',
  MATERIAL_HIERARCHY: 'material-hierarchy',
  MATERIAL_ASSIGNMENT: 'material-assignment',
  CATEGORY: 'category',
  MATRIX_CATEGORY: 'matrix-category',
})
